module.exports = __webpack_public_path__ + "static/media/3.15338f1d.png";